/* src/app/private/components/tickets/ticket-timeline/ticket-timeline.component.scss */
.timeline-marker {
  background-color: var(--primary-color) !important;
  color: #fff;
  font-weight: 600;
  font-size: 11px;
}
.marker-creation {
  background-color: #10b981 !important;
}
.marker-assignment {
  background-color: #3b82f6 !important;
}
.marker-update {
  background-color: #f59e0b !important;
}
.marker-comment {
  background-color: #8b5cf6 !important;
}
.marker-attachment {
  background-color: #ef4444 !important;
}
.marker-default {
  background-color: #6b7280 !important;
}
.ticket-timeline {
  padding: 0;
  margin: 0;
}
.ticket-timeline .p-timeline .p-timeline-event {
  margin-bottom: 1.5rem;
}
.timeline-content {
  padding: 1rem;
  border-radius: 8px;
  border: 1px solid #e9ecef;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  margin-bottom: 15px;
}
.timeline-content:hover {
  background: var(--secondry-light-gray);
  transition: background-color 0.3s ease;
}
.timeline-type-badge {
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
}
.badge-creation {
  background-color: #d1fae5;
  color: #065f46;
}
.badge-assignment {
  background-color: #dbeafe;
  color: #1e40af;
}
.badge-update {
  background-color: #fef3c7;
  color: #92400e;
}
.badge-comment {
  background-color: #ede9fe;
  color: #5b21b6;
}
.badge-attachment {
  background-color: #fee2e2;
  color: #991b1b;
}
.badge-default {
  background-color: #f3f4f6;
  color: #374151;
}
.attachment-link {
  text-decoration: underline;
  color: #3b82f6;
  font-weight: 500;
}
.attachment-link:hover {
  color: #1d4ed8;
}
.p-timeline-left .p-timeline-event-opposite {
  display: none;
}
/*# sourceMappingURL=ticket-timeline.component.css.map */
